export const themeStyleDark = {
  backgroundColor: "#F4F5FA",
  primaryColor: "#090979",
  primaryCardColor: "white",
  textColor: "black",
  primaryButtonColor: "#090979",
  primaryButtonTextColor: "white",
  secondaryButtonColor: "#090979",
};

export const themeStyle = {
  backgroundColor: "#F4F5FA",
  primaryColor: "#090979",
  primaryCardColor: "white",
  textColor: "black",
  primaryButtonColor: "#090979",
  primaryButtonTextColor: "black",
  secondaryButtonColor: "#090979",
};
